// extracted by mini-css-extract-plugin
export var numpadContainer = "_kd-1";
export var phoneButton = "_kd-0";